/** Fits world XZ points into a w x h box (north = +z up, aspect kept) and builds SVG path data. Pure. */
export interface XZ { x: number; z: number }
export type Project = (x: number, z: number) => [number, number];

export function fitProjector(points: readonly XZ[], w: number, h: number, pad = 8): Project {
  let minX = Infinity, maxX = -Infinity, minZ = Infinity, maxZ = -Infinity;
  for (const p of points) { minX = Math.min(minX, p.x); maxX = Math.max(maxX, p.x); minZ = Math.min(minZ, p.z); maxZ = Math.max(maxZ, p.z); }
  if (!Number.isFinite(minX)) return () => [w / 2, h / 2];
  const sx = (w - 2 * pad) / Math.max(1e-6, maxX - minX), sz = (h - 2 * pad) / Math.max(1e-6, maxZ - minZ);
  const s = Math.min(sx, sz);
  const ox = (w - (maxX - minX) * s) / 2, oz = (h - (maxZ - minZ) * s) / 2;
  // Screen x grows with world -x: the chase camera looks down +z with +x on the left (A steers left = +x side).
  return (x, z) => [w - (ox + (x - minX) * s), h - (oz + (z - minZ) * s)];
}

export function pathData(points: readonly XZ[], project: Project, closed: boolean): string {
  if (!points.length) return '';
  const d = points.map((p, i) => {
    const [x, y] = project(p.x, p.z);
    return `${i ? 'L' : 'M'}${x.toFixed(1)} ${y.toFixed(1)}`;
  }).join('');
  return closed ? `${d}Z` : d;
}
